import React, { useEffect, useState } from "react";
import {
	Col,
	Container,
	Row,
	Breadcrumb,
	BreadcrumbItem,
	Progress,
	Label,
} from "reactstrap";
import pdf from "assets/pdf/terms.pdf";
import "assets/scss/website/app.scss";
import { MetaTags } from "react-meta-tags";
import { Link } from "react-router-dom";
import "react-rangeslider/lib/index.css";
import { AvForm, AvRadioGroup, AvRadio } from "availity-reactstrap-validation";
import "./styles.scss";
import StepOne from "./StepOne";
import StepTwo from "./StepTwo";
import StepFour from "./StepFour";
import StepFive from "./StepFive";
import ResaleService from "services/Website/ResaleService";
import { SuccessOk, SuccessCreated } from "configs/statusCode";
import CompoundService from "services/Admin/CompoundService";
import SuccessModal from "./SuccessModal";
import PhotoStep from "./PhotoStep";
import CancelModal from "components/CancelModal";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { facingPlaces, furnishing } from "Enums/fixedData";
import StepsFileds from "./StepsFileds";
import Terms from "./Terms";
import SummaryPage from "./Summary";
import { amenitiesOptions } from "Enums/fixedData";
import ResaleHeader from "./Header";

const CreateResale = (props) => {
	const { t } = useTranslation();
	const [loading, setLoading] = useState(false);
	const [modal, setModal] = useState(false);
	const resaleService = new ResaleService();
	const [successmodal, setSuccessModal] = useState(false);
	const [agree, setAgree] = useState(true);
	const AuthData = useSelector((state) => state.Auth);
	const [formStep, setFormStep] = useState(16);
	const [payment, setPayment] = useState({});
	const [media, setMedia] = useState([]);
	const [agreeTerms, setAgreeTerms] = useState(false);
	const [formData, setFormData] = useState({
		in_compound: false,
		selectedCompound: null,
		en: "",
		ar: "",
		ru: "",
		zh: "",
		descrip_ar: "",
		descrip_en: "",
		descrip_ru: "",
		descrip_zh: "",
		propertType: null,
		selectedCity: null,
		governorate: null,
		street_address: {
			ar: "",
			en: "",
			ru: "",
			zh: "",
		},
		area_id: "",
		lat: "",
		lang: "",
		facing: null,
		selectedFinishingType: null,
		floor: "",
		bedrooms: "",
		bathrooms: "",
		furnishing: null,
		payment_plan: {
			off_payments: [],
			recurring_payments: [],
		},
		inputLang: "en",
		amenities: [],
		bank_account: "",
		swift: "",
		iban: "",
		images_ids: [],
		mediaIds: [],
		contracts_ids: [],
		contractsIds: [],
		national_ids: [],
		nationalIds: [],
		videos_ids: [],
		videosIds: [],
		terms_and_conditions_ids: [],
		termsAndConditionsIds: [],
		total_land_area: null,
		hasAmenities: false,
		amenitiesOther: {
			label: "",
			en: "",
			ru: "",
			ar: "",
			zh: "",
		},
		showMap: false,
		payment_method: "",
	});
	const id = props.match.params.id;

	const goBackHandler = () => {
		setFormStep(formStep - 16);
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	};

	// useEffect(() => {
	//     if (!id) {
	//         setShowModal(true)
	//     }
	// }, [])

	// useEffect(() => {
	//     if (!id && agree){
	//         setModal(true)
	//     }
	// }, [agree])

	const compoundService = new CompoundService();
	const getEditResaleData = async () => {
		//const response = await compoundService.getDropDown()
		// const newOptions = response.data.map(item => {
		//     return {
		//         label: item.name.en,
		//         value: item.id
		//     }
		// })

		if (id) {
			setFormStep(64);
			resaleService.find(id).then((res) => {
				if (res && res.status === SuccessOk) {
					let selectedFurnishing = furnishing.find(
						(item) => item.value === res.data.furnishing
					);
					let selectedFacing = facingPlaces.find(
						(item) => item.value === res.data.facing
					);

					//const compound = newOptions.find(item => item.label === res.data.compound_name)
					setAgree(true);

					let newAmenities = !!res.data?.amenities
						? res.data?.amenities?.filter(({ label: id1 }) =>
								amenitiesOptions.some(({ label: id2 }) => id1 === id2)
						  )
						: [];
					let newAmenitiesOther = !!res.data?.amenities
						? res.data?.amenities?.filter(
								({ label: id1 }) =>
									!amenitiesOptions.some(({ label: id2 }) => id1 === id2)
						  )
						: [];
					setFormData({
						...formData,
						payment_method: res.data.payment_plan.payment_method,
						payment_plan: res.data.payment_plan,

						in_compound: res.data.in_compound,
						ar: res.data.name.ar,
						en: res.data.name.en,
						ru: res.data.name.ru,
						zh: res.data.name.zh,
						selectedCompound: {
							value: res.data.compound.id,
							label: res.data.compound.name,
						},
						propertType: {
							id: res.data.unit_type.id,
							label: res.data.unit_type.name.en,
							...res.data.unit_type.name,
						},
						selectedFinishingType: {
							label: res.data.finishing_type.name[`${AuthData.lang}`],
							value: res.data.finishing_type.id,
						},
						lat: !!res.data.location.lat ? res.data.location.lat : "",
						lang: !!res.data.location.lang ? res.data.location.lang : "",
						showMap:
							!!res.data.location.lat && !!res.data.location.lang
								? true
								: false,
						selectedCity: {
							...res.data.location.City,
							label: res.data.location.City.label,
						},
						governorate: res.data.location.governorate,

						bedrooms: res.data.bedrooms,
						floor: res.data.floor,
						bathrooms: res.data.bathrooms,
						furnishing: {
							...selectedFurnishing,
							label: selectedFurnishing[`${AuthData.lang}`],
						},
						facing: {
							...selectedFacing,
							label: selectedFacing[`${AuthData.lang}`],
						},
						status: res.data.status,
						descrip_ar: res.data.description.ar,
						descrip_en: res.data.description.en,
						descrip_ru: res.data.description.ru,
						descrip_zh: res.data.description.zh,
						// address_ar: res.data.location.street_address.ar,
						// address_en: res.data.location.street_address.en,
						// address_ru: res.data.location.street_address.ru,
						// address_zh: res.data.location.street_address.zh,
						street_address: {
							ar: res.data.location.street_address.ar,
							en: res.data.location.street_address.en,
							ru: res.data.location.street_address.ru,
							zh: res.data.location.street_address.zh,
						},
						amenities:
							newAmenitiesOther?.length > 0
								? [...newAmenities, { label: "Other", value: "Other" }]
								: [...newAmenities],
						amenitiesOther: { ...newAmenitiesOther[0] },
						hasAmenities: res.data?.amenities?.length > 0 ? true : false,
						total_built_up_area: res.data?.total_built_up_area,
						total_land_area: res.data?.total_land_area,
						images_ids: [...res.data.images_ids],
						videos_ids: [...res.data?.videos_ids],

						selectedCity: {
							...res.data.location.City,
							label: res.data.location.City?.label,
						},
						area: {
							value: res.data.area?.id,
							label: res.data.area?.name,
						},
						bank_account: res.data.bank_account,
						iban: res.data.iban,
						swift: res.data.swift,
						contracts_ids: [...res.data.contracts_ids],
						national_ids: [...res.data.national_ids_ids],
						terms_and_conditions_ids: [...res.data.terms_and_conditions_ids],
						contractsIds: [...res.data.contracts],
						mediaIds: [...res.data.images],
						videosIds: [...res.data.videos],
						nationalIds: [...res.data.national_ids_images],
						termsAndConditionsIds: [...res.data.terms_and_conditions],
					});
					setAgreeTerms(true);
					//  setContractsIds([...res.data.contracts])
					//  setMediaIds([...res.data.images])
					//  setVideoIds([...res.data.videos])
					//  setNationalId([...res.data.national_ids_images])
					//  setTermsAndConditionsIds([...res.data.terms_and_conditions])
					//setFormStep(20)
				}
			});
		}
	};

	useEffect(() => {
		getEditResaleData();
	}, [AuthData.lang]);

	const updateStateHandler = (data) => {
		setFormData({
			...formData,
			...data,
		});

		setFormStep(formStep + 16);

		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	};

	const createResale = () => {
		let newAmenities = formData.amenities?.filter(
			(item) => item.label !== "Other"
		);
		if (!!formData?.amenitiesOther.label) {
			newAmenities.push(formData?.amenitiesOther);
		}
		let data = {
			unit_type_id: formData?.propertType?.id,
			in_compound: formData?.in_compound,
			compound_id: formData?.selectedCompound?.value,
			name: {
				ar: formData?.ar,
				en: formData?.en,
				ru: formData?.ru,
				zh: formData?.zh,
			},
			description: {
				ar: formData.descrip_ar,
				en: formData.descrip_en,
				ru: formData.descrip_ru,
				zh: formData.descrip_zh,
			},
			facing: formData.facing?.value,
			finishing_type_id: formData.selectedFinishingType?.value,
			furnishing: formData.furnishing[formData.inputLang],
			bedrooms: parseInt(formData.bedrooms),
			bathrooms: parseInt(formData.bathrooms),
			total_built_up_area: parseInt(formData?.total_built_up_area),
			floor: parseInt(formData.floor),
			total_land_area: formData?.standalone
				? parseInt(formData?.total_land_area)
				: null,
			amenities: formData?.amenities?.length > 0 ? [...newAmenities] : [],
			images_ids: [...formData.images_ids],
			videos_ids: [...formData?.videos_ids],
			location: {
				lat: formData?.lat,
				lang: formData?.lang,
				governorate: formData?.governorate,
				City: formData.selectedCity,
				street_address: { ...formData.street_address },
			},
			area_id: formData.area?.value,
			contracts_ids: [...formData.contracts_ids],
			national_ids: [...formData.national_ids],
			terms_and_conditions_ids: [...formData.terms_and_conditions_ids],
			bank_account: formData.bank_account,
			swift: formData.swift,
			iban: formData.iban,

			total_price: formData.total_price,
			payment_method: formData.payment_method,
			depost: formData.depost,
			in_owner_installment:
				formData.payment_method === "Owner Installment" ? true : false,
			...payment,
		};
		let paymentData;
		if (
			formData.payment_method !== "" &&
			formData.payment_method === "Installment"
		) {
			paymentData = {
				years: [
					{
						years: parseFloat(formData.years),
						down_payment: parseFloat(formData.down_payment),
						recurring_payments: [
							{ payment_frequency: formData.payment_frequency.label },
						],
					},
				],
			};
		} else if (
			formData.payment_method !== "" &&
			formData.payment_method === "Owner Installment"
		) {
			paymentData = {
				remaining_price: parseFloat(formData.remaining_price),
				until_month: formData.until_month,
				until_year: formData.until_year,
				off_payments: formData.off_payments,
				recurring_payments: [
					{ payment_frequency: formData.payment_frequency.label },
				],
			};
		}

		setLoading(true);

		if (id) {
			resaleService.update(id, { ...data, ...paymentData }).then((res) => {
				if (res && res.status === SuccessOk) {
					setSuccessModal(true);
				}
			});
		} else {
			resaleService.create({ ...data, ...paymentData }).then((response) => {
				if (response && response.status === SuccessCreated) {
					setSuccessModal(true);
				}
			});
		}

		setLoading(false);

		// if (formData.in_compound) allData["compound_name"] = formData.selectedCompound.label
		// if (id) {
		//     allData["status"] = formData.status
		//     resaleService.update(id, allData).then(response => {
		//         if (response && response.status === SuccessOk) {
		//             // setShowModal(false)
		//             setSuccessModal(true)
		//             setLoading(false)

		//             // toast.success("Resale updated successfully")
		//             // props.history.push("/Profile")
		//         } else {
		//             setLoading(false)

		//         }
		//     })
		// } else {

		// }
	};

	return (
		<div className="resalePage">
			<MetaTags>
				<title>{t("resale")}</title>
			</MetaTags>
			<div>
				{formStep === 16 && (
					<>
						<div className="resalePage-header">
							<ResaleHeader />
						</div>
						<div className="first-step">
							<div className="container">
								<p className="title">{t("SELL YOUR PROPERTY WITH MERAS")}</p>
								<p className="sub-title">
									{t("By easy steps you will add your property to sell")}
								</p>
								<div className="steps row">
									<div className="col-lg-4 col-md-6">
										<div className="step">
											<p className="step-main-title">{t("Step One")}</p>
											<p className="step-title">{t("All Property Details")}</p>
											<p className="details">
												Add all the information related to your property.
											</p>
										</div>
									</div>
									<div className="col-lg-4 col-md-6">
										<div className="step">
											<p className="step-main-title">{t("Step Two")}</p>
											<p className="step-title">{t("Media")}</p>
											<p className="details">
												Add all photos and videos related to your property
											</p>
										</div>
									</div>
									<div className="col-lg-4 col-md-6">
										<div className="step">
											<p className="step-main-title">{t("Step Three")}</p>
											<p className="step-title">{t("Location")}</p>
											<p className="details">Add the location of your property</p>
										</div>
									</div>
									<div className="col-lg-4 col-md-6">
										<div className="step">
											<p className="step-main-title">{t("Step Four")}</p>
											<p className="step-title">{t("Contract Copy")}</p>
											<p className="details">
												Upload the contract of your property
											</p>
										</div>
									</div>
									<div className="col-lg-4 col-md-6">
										<div className="step">
											<p className="step-main-title">{t("Step Five")}</p>
											<p className="step-title">{t("Payment Details")}</p>
											<p className="details">
												Choose between three Payment Systems and Complete their
												data
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</>
				)}
				<div className={`container ${formStep > 16 ? "pt-11rem" : ""}`}>
					{agree ? (
						<div>
							{/* <StartModal modal={modal} onClick={() => setModal(false)} /> */}
							<SuccessModal
								modal={successmodal}
								id={id}
								onClick={() => {
									props.history.push("/");
								}}
							/>
							{formStep > 16 && (
								<Progress className="p-0" value={`${formStep}`} max={144} />
							)}
							<div className="steps-width">
								{formStep > 16 && (
									<h4
										className="p-0 step-maintitle"
										dangerouslySetInnerHTML={{
											__html:
												formStep === 32
													? t("Property Details")
													: formStep === 48
													? t("Media")
													: formStep === 64
													? t("location")
													: formStep === 80
													? t("Contract Cover Copy")
													: formStep === 96
													? t("Payment details")
													: t("Summary"),
										}}></h4>
								)}

								{formStep === 16 && (
									<div className="first-step-details">
										<h4 className="title">
											{t("Choose This Fields To Continue The Property Process")}
										</h4>
										<h4 className="font-size-24 text-primary fw-bold">
											{t("Language")}
										</h4>
										<p className="font-size-16 text-primary">
											{t(
												"Select the language in which the data will be entered"
											)}
										</p>
										<AvForm onValidSubmit={updateStateHandler}>
											<Col className="radio-box">
												<AvRadioGroup
													className="mt-2"
													inline
													name="inputLang"
													required
													value={formData.inputLang}
													onChange={(e) => {
														setFormData({
															...formData,
															inputLang: e.target.value,
														});
													}}>
													<AvRadio label={"English"} value="en" />
													<AvRadio label={"Arabic"} value="ar" />
													<AvRadio label={"Russian"} value="ru" />
													<AvRadio label={"Chinese"} value="zh" />
												</AvRadioGroup>
											</Col>
											<h4 className="font-size-24 text-primary fw-bold">
												{t("Terms and Conditions")}
											</h4>
											<p className="font-size-16 text-primary">
												{t("Download pdf file, signed it and Uploaded again")}
											</p>
											<a
												href={pdf}
												download="terms"
												className="btn mb-2 mt-3"
												style={{
													fontSize: "14px",
													padding: "6px 30px",
													borderColor: "var(--primary-color)",
													borderRadius: "30px",
													color: "var(--primary-color)",
													background: "var(--body-bg)",
												}}>
												<i
													className="fas fa-file-download my-2"
													style={{ marginRight: "12px" }}></i>
												Download PDF to signed it
											</a>

											<div>
												<label className="text-primary mb-0">
													<input
														name="agree"
														type="checkbox"
														checked={agreeTerms}
														onChange={(e) => setAgreeTerms(e.target.checked)}
													/>
													{t("I have downloaded the file and signed it")}
												</label>
												<button
													type="submit"
													disabled={!agreeTerms}
													style={{
														borderRadius: "5px",
														borderColor: "var(--primary-color)",
														background: "var(--primary-color)",
													}}
													className="btn btn-success py-2 px-4 d-block mt-3">
													Next
												</button>
											</div>
										</AvForm>
									</div>
								)}
								{/* {formStep === 32 && (
								<>
									<StepsFileds
										setModal={setModal}
										goBackHandler={goBackHandler}
										nextStep={() => {
											setFormStep(formStep + 32);
											window.scrollTo({
												top: 0,
												behavior: "smooth",
											});
										}}
									/>
								</>
							)}
							{formStep === 48 && (
								<Terms
									setModal={setModal}
									goBackHandler={goBackHandler}
									agreeTerms={agreeTerms}
									setAgreeTerms={setAgreeTerms}
									nextStep={() => {
										setFormStep(formStep + 16);
										window.scrollTo({
											top: 0,
											behavior: "smooth",
										});
									}}
								/>
							)} */}
								{formStep === 32 && (
									<StepOne
										inputLang={formData.inputLang}
										stateData={{
											in_compound: formData?.in_compound,
											selectedCompound: formData?.selectedCompound,
											ar: formData.ar,
											en: formData.en,
											ru: formData.ru,
											zh: formData.zh,
											propertType: formData.propertType,
											descrip_ar: formData.descrip_ar,
											descrip_en: formData.descrip_en,
											descrip_ru: formData.descrip_ru,
											descrip_zh: formData.descrip_zh,
											facing: formData.facing,
											selectedFinishingType: formData.selectedFinishingType,
											floor: formData.floor,
											bedrooms: formData.bedrooms,
											bathrooms: formData.bathrooms,
											furnishing: formData.furnishing,
											amenities: formData.amenities,
											total_built_up_area: formData.total_built_up_area,
											total_land_area: formData?.total_land_area,
											amenitiesOther: formData.amenitiesOther,
											hasAmenities: formData.hasAmenities,
										}}
										setModal={setModal}
										goBackHandler={goBackHandler}
										updateStateHandler={updateStateHandler}
									/>
								)}
								{formStep === 48 && (
									<PhotoStep
										stateData={{
											images_ids: formData.images_ids,
											videos_ids: formData.videos_ids,
											videosIds: formData.videosIds,
											mediaIds: formData.mediaIds,
										}}
										setMedia={setMedia}
										setModal={setModal}
										updateStateHandler={updateStateHandler}
										goBackHandler={goBackHandler}
									/>
								)}
								{formStep === 64 && (
									<StepTwo
										inputLang={formData.inputLang}
										setModal={setModal}
										locationData={{
											lat: formData?.lat,
											lang: formData?.lang,
											showMap: formData.showMap,
											governorate: formData?.governorate,
											selectedCity: formData?.selectedCity,
											street_address: {
												ar: formData.street_address.ar,
												en: formData.street_address.en,
												ru: formData.street_address.ru,
												zh: formData.street_address.zh,
											},
											area: formData.area,
										}}
										updateStateHandler={updateStateHandler}
										goBackHandler={goBackHandler}
									/>
								)}
								{formStep === 80 && (
									<StepFour
										stateData={{
											contracts_ids: formData.contracts_ids,
											national_ids: formData.national_ids,
											terms_and_conditions_ids:
												formData.terms_and_conditions_ids,
											bank_account: formData.bank_account,
											iban: formData.iban,
											swift: formData.swift,
											contractsIds: formData.contractsIds,
											nationalIds: formData.nationalIds,
											termsAndConditionsIds: formData.termsAndConditionsIds,
										}}
										setModal={setModal}
										updateStateHandler={updateStateHandler}
										goBackHandler={goBackHandler}
									/>
								)}
								{formStep === 96 && (
									<StepFive
										setModal={setModal}
										goBackHandler={goBackHandler}
										id={id}
										data={formData}
										updateStateHandler={updateStateHandler}
										loading={loading}
									/>
								)}
								{formStep === 112 && (
									<SummaryPage
										setModal={setModal}
										id={id}
										inputLang={formData.inputLang}
										goBackHandler={goBackHandler}
										data={formData}
										createResale={createResale}
									/>
								)}
							</div>
						</div>
					) : (
						<Row style={{ height: "20rem" }}>
							{/* <TermsModal
                                showModal={showModal}
                                setShowModal={setShowModal}
                                setAgree={setAgree}
                                agree={agree}
                                history={props.history}
                            />*/}
						</Row>
					)}
					<CancelModal
						modal={modal}
						setModal={setModal}
						goBackHandler={() => props.history.push("/")}
					/>
				</div>
			</div>
		</div>
	);
};

export default CreateResale;
